<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroCircleStack"></ng-icon>
      <h2>Attributes</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Attributes</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off">
          <mat-icon matSuffix><ng-icon name="heroMagnifyingGlass"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      <button color="accent" mat-raised-button [disabled]="!userService.permissionsValue['_CONTRACT_TYPE_ADD_']"
      [routerLink]="['/app/attributes/add']">
      Add Attribute </button>
    </div>
  </div>
  <div class="inner-box">
    <mat-table [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Attribute Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Attribute Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple
            [routerLink]="['/app/attributes', 'view', element.seedAttributeId]"
            matTooltip="View Attribute {{element.label }}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100">{{ element.label }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Section">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Section</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.sectionName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Default Value">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Default Value</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.defaultValue }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.updatedDate }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple [disabled]="!userService.permissionsValue['_CONTRACT_TYPE_EDIT_']"
            [routerLink]="['/app/attributes', 'edit', element.seedAttributeId]"
            matTooltip="Edit Attribute {{element.label }}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100"><ng-icon name="heroPencil"></ng-icon></a>

            <a mat-button color="accent" disableRipple (click)="openDeleteConfirmation(element.seedAttributeId)"
            matTooltip="Delete {{element.label | titlecase }}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100"><ng-icon
              name="heroTrash"></ng-icon></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.filter &&  dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no attributes found with <strong>'{{dataSource.filter}}'</strong></p>
      </div>
    </ng-container>

    <ng-container *ngIf="dataLoading">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <ng-container *ngIf="dataSource.data.length === 0 && !dataSource.filter && !dataLoading">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no attributes found.</p>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>